<template>
	<div>
		<!-- 좌측 데이터 영역 -->
		<div class="screening-left-wrap">
			<p class="page-title">Collect Data</p>
			<!-- 데이터 검색 -->
			<input type="text" class="input-list-search" placeholder="Please enter the numbering." />
			<p class="list-title">Data List</p>
			<!-- 데이터 리스트 wrap -->
			<div class="list-wrap scroll">
				<div
					v-for="(item, index) in screeningList"
					:key="index"
					class="list-item no-drag"
					:class="selectedScreeningNo == item.screeningNo ? 'select' : ''"
					@click="selectData(item)"
				>
					{{ item.screeningName }}
					<div
						v-if="item.openQueryYn > 0"
						class="openQueryDataList"
					>
						!
					</div>
				</div>
			</div>
		</div>
		<!-- 중앙 컨테이너 wrap -->
		<div class="screening-center-wrap">
			<p class="schedule-title">
				{{ selectedScreeningName }}
			</p>
			<!-- <button
				type="button"
				class="pdf-btn"
				title="New Visit"
				@click="pdfDown(1)"
				style="right: 170px;"
			>
				Blank PDF
			</button> -->
			<!-- <button
				type="button"
				class="pdf-btn"
				title="New Visit"
				@click="pdfDown(3)"
			>
				Completion PDF
			</button> -->
			<div class="schedule-status">
				<!-- <i class="schedule-disabled" /> Disabled  -->
				<i class="schedule-wait" /> 입력 전
				<!-- <i class="schedule-temp" /> Temp Save  -->
				<i class="schedule-success" /> 입력 완료
				<!-- <i class="schedule-compare" /> Monitoring Request 
				<i class="schedule-modify" /> Request Edit 
				<i class="schedule-pass" /> End Monitoring 
				<i class="schedule-sign" /> PI Signature 
				<i class="schedule-freezing" /> Data Freezing -->
			</div>
			<div class="scroll-wrap">
				<div class="scroll-thead-wrap" :style="headRowSet()">
					<table class="schedule-table">
						<thead>
							<tr ref="headRow">
								<th></th>
								<template v-for="(item, index) in visitList">
									<th v-if="item.unscheduleYn == 'Y' && index == 2" :key="index">
										<span
											
											@click="updateUnAdd(item)"
											style="text-decoration: underline; cursor: pointer;"
										>
											{{ item.visitName }}
										</span>
									</th>
									<th v-else-if="item.unscheduleYn == 'N' && item.useYn =='Y' && index == 2" :key="item.visitNo + index" :style="headThSet()">
										<span>
											{{ item.visitName }}
										</span>
									</th>
								</template>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(pageItem, pageIndex) in pageList" :key="pageIndex">
								<th>
									{{ pageItem.pageLabel }}
								</th>
								<template
									v-for="(visitItem, visitIndex) in visitList"
								>
									<td v-if="visitItem.unscheduleYn == 'Y' && visitIndex == 2" :key="visitIndex">
										<button
											v-if="visitItem.visitPageList.indexOf(pageItem.pageNo) > -1 && visitItem.useYn == 'Y'"
											class="schedule-icon"
											:class="{
												'schedule-wait' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == null || visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '1',
												'schedule-temp' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '2',
												'schedule-success' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '3',
												'schedule-compare' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '4',
												'schedule-modify' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '5',
												'schedule-pass' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '6',
												'schedule-sign' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '7',
												'schedule-freezing' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '8',
												'schedule-disabled' : disabledCheck(pageItem, visitItem, visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)]),
											}"
											@click="selectPage(pageItem, visitItem)"
										></button>
									</td>
									<td v-else-if="visitItem.unscheduleYn == 'N' && visitItem.useYn =='Y' && visitIndex == 2" :key="visitItem.visitNo + visitIndex">
										<button
											v-if="visitItem.visitPageList.indexOf(pageItem.pageNo) > -1 && visitItem.useYn == 'Y'"
											class="schedule-icon"
											:class="{
												'schedule-wait' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == null || visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '1',
												'schedule-temp' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '2',
												'schedule-success' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '3',
												'schedule-compare' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '4',
												'schedule-modify' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '5',
												'schedule-pass' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '6',
												'schedule-sign' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '7',
												'schedule-freezing' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '8',
												'schedule-disabled' : disabledCheck(pageItem, visitItem, visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)]),
											}"
											@click="selectPage(pageItem, visitItem)"
										></button>
									</td>
								</template>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="scroll-tbody-wrap scroll">
					<table class="schedule-table">
						<thead>
							<tr>
								<th></th>
								<template v-for="(item, index) in visitList">
									<th v-if="item.unscheduleYn == 'Y' && index == 2" :key="index">
										<span
											
											@click="updateUnAdd(item)"
											style="text-decoration: underline; cursor: pointer;"
										>
											{{ item.visitName }}
										</span>
									</th>
									<th v-else-if="item.unscheduleYn == 'N' && item.useYn =='Y' && index == 2" :key="item.visitNo + index">
										<span>
											{{ item.visitName }}
										</span>
									</th>
								</template>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(pageItem, pageIndex) in pageList" :key="pageIndex">
								<th>
									{{ pageItem.pageLabel }}
								</th>
								<template
									v-for="(visitItem, visitIndex) in visitList"
								>
									<td v-if="visitItem.unscheduleYn == 'Y' && visitIndex == 2" :key="visitIndex">
										<button
											v-if="visitItem.visitPageList.indexOf(pageItem.pageNo) > -1 && visitItem.useYn == 'Y'"
											class="schedule-icon"
											:class="{
												'schedule-wait' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == null || visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '1',
												'schedule-temp' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '2',
												'schedule-success' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '3',
												'schedule-compare' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '4',
												'schedule-modify' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '5',
												'schedule-pass' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '6',
												'schedule-sign' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '7',
												'schedule-freezing' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '8',
												'schedule-disabled' : disabledCheck(pageItem, visitItem, visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)]),
											}"
											@click="selectPage(pageItem, visitItem)"
										></button>
									</td>
									<td v-else-if="visitItem.unscheduleYn == 'N' && visitItem.useYn =='Y' && visitIndex == 2" :key="visitItem.visitNo + visitIndex">
										<button
											v-if="visitItem.visitPageList.indexOf(pageItem.pageNo) > -1 && visitItem.useYn == 'Y'"
											class="schedule-icon"
											:class="{
												'schedule-wait' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == null || visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '1',
												'schedule-temp' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '2',
												'schedule-success' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '3',
												'schedule-compare' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '4',
												'schedule-modify' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '5',
												'schedule-pass' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '6',
												'schedule-sign' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '7',
												'schedule-freezing' : visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)] == '8',
												'schedule-disabled' : disabledCheck(pageItem, visitItem, visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)]),
											}"
											@click="selectPage(pageItem, visitItem)"
										></button>
										<div
											v-if="visitItem.openQueryList.indexOf(pageItem.pageNo) > -1 && visitItem.useYn == 'Y'"
											class="queryOpened"
										>!</div>
									</td>
								</template>
							</tr>
						</tbody>
					</table>
					<button
						type="button"
						class="btn-new fright"
						title="New Visit"
						style="margin-top: 15px;"
						@click="completeInsert()"
					>
						등록 완료 하기
					</button>
				</div>
			</div>
		</div>
		<ScreeningSingleCreate v-if="isSingleCreate" :param="paramSigleCreate" />
		<preScreeningSingleCreate v-if="isPreSingleCreate" :param="paramSigleCreate" />
		<ScreeningMultipleList v-if="isMultipleList" :param="paramMultipleList" />
		<ScreeningUnAdd v-if="isUnAdd" :siteCode="this.siteCode" :screeningNo="this.items.screeningNo"/>
		<ScreeningUnUpdate v-if="isUnUpdate" :siteCode="this.siteCode" :unUpdate="this.unUpdate"/>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
import ScreeningSingleCreate from "@/components/project/screening/ScreeningSingleCreate.vue";
import preScreeningSingleCreate from "@/components/preRegistration/preScreeningSingleCreate.vue";
import ScreeningMultipleList from "@/components/project/screening/ScreeningMultipleList.vue";
import ScreeningUnAdd from "@/components/project/screening/ScreeningUnAdd.vue";
import ScreeningUnUpdate from "@/components/project/screening/ScreeningUnUpdate.vue";

export default {
	name: "preScreeningEntryList",
	components: {
		ScreeningSingleCreate,
		preScreeningSingleCreate,
		ScreeningMultipleList,
		ScreeningUnAdd,
		ScreeningUnUpdate,
	},
	created() {
		this.logger.debug(this, "created()");
		this.items.projectNo = this.$route.params.projectNo;
		this.items.screeningNo = this.$route.params.screeningNo;
		this.selectedScreeningNo = this.$route.params.screeningNo;
		this.disableApply();
		this.selectProjectItem();
		this.selectScreeningList();
		this.selectDataVisitList();
		this.selectPageList();
		this.selectValidList();
		this.selectItemList();
		this.getAccessList('ENTRY');
		this.getProjectStateCd();

		// 리스트 새로고침
		EventBus.$on("refresh-data-list", (selectedScreeningNo) => {
			this.logger.debug(this, "[EventBus] refresh-data-list(" + selectedScreeningNo + ")");
		});
	},
	updated(){
		this.headRow();
	},
	data() {
		return {
			items: {},
			screeningList: [],
			selectedScreeningNo: "",
			visitList: [],
			pageList: [],
			validList : [],
			itemList : [],
			paramSigleCreate: {},
			paramMultipleList: {},
			projectItem: {},
			visitpageList: [],
			isSingleCreate: false,
			isPreSingleCreate: false,
			isMultipleList: false,
			isUnAdd: false,
			isUnUpdate: false,
			siteCode: "",
			disablePageList: [],
			disableProcList: [],
			disableQuestionList: [],
			validResultMsg: [],
			unUpdate: [],
			accessList: [],
			projectStateCd: "",
			applyValidVoList: [],
			height: "",
		};
	},
	computed: {
		selectedScreeningName: function () {
			let indexList = this.screeningList.map((item) => {
				return item.screeningNo;
			});
			let nameList = this.screeningList.map((item) => {
				return item.subjectNo;
			});
			let selectedIndex = indexList.indexOf(this.selectedScreeningNo);

			return nameList[selectedIndex];
		},
	},
	methods: {
		completeInsert(){
			var cnt = 0;
			for(var i = 0; i < this.pageList.length; i++){
				for(var j = 0; j < this.visitList.length; j++){
					if(this.visitList[j].visitPageUserList[this.visitList[j].visitPageList.indexOf(this.pageList[i].pageNo)] == '3'){
						cnt++;
					}
				}
			}

			if(cnt != 7){
				this.$alert("입력이 안된 페이지가 있습니다.","Warning","warning");
			}
			else{
				this.$confirm("등록을 완료 하시겠습니까?", "Success", "success").then(() => {
					EventBus.$emit("project-loading", true);
					this.$router.push(this.$route.query.redirect || this.config.contextRoot + "/preRegistrationEnd");
				});
			}
		},
		selectProjectItem() {
			if (this.$route.params.projectNo === undefined || this.$route.params.projectNo == "") this.projectNo = "";
			else {
				this.projectNo = this.$route.params.projectNo;
				axios
					.post(this.config.contextRoot + "/project/select.do", {projectNo: this.projectNo})
					.then((response) => {
						console.log(response);
						this.projectItem = response.data.item;
						EventBus.$emit("project-loading", false);
					})
					.catch((error) => {
						this.exceptionHandler(this, error);
					});
			}
		},
		disableApply(){
			this.logger.debug(this, "disableApply()");
			axios
				.post(this.config.contextRoot + "/screening/disableApply.do", this.items)
				.then((response) => {
					console.log(response);
					this.applyValidVoList = response.data.applyValidVoList;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectScreeningList() {
			this.logger.debug(this, "selectScreeningList()");
			axios
				.post(this.config.contextRoot + "/screening/selectList.do", this.items)
				.then((response) => {
					console.log(response);
					this.screeningList = response.data.screeningList;
					this.siteCode = this.screeningList[0].siteCode;

					this.$nextTick(function () {
						setTimeout(
							function () {
								EventBus.$emit("project-loading", false);
							}.bind(this),
							500
						);
					});
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectDataVisitList() {
			this.logger.debug(this, "selectDataVisitList()");

			let param = {
				projectNo: this.items.projectNo,
				screeningNo: this.selectedScreeningNo,
			}
			axios
				.post(this.config.contextRoot + "/screening/dataVisitList.do", param)
				.then((response) => {
					console.log(response);
					this.visitList = response.data.dataVisitList;

				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectPageList() {
			this.logger.debug(this, "selectPageList()");
			axios
				.post(this.config.contextRoot + "/schedule/selectPageList.do", {projectNo: this.items.projectNo})
				.then((response) => {
					console.log(response);
					var onList1 = [13, 14, 15];
					var onList2 = [6, 7, 16, 18];
					
					for(var i = 0; i < response.data.pageList.length; i++){
						if(this.$route.query.osType == 1 && onList1.includes(i)){
							this.pageList.push(response.data.pageList[i]);	
						}
						if(this.$route.query.osType == 2 && onList2.includes(i)){
							this.pageList.push(response.data.pageList[i]);	
						}
					}
					// this.pageList = response.data.pageList;
					// this.pageList.shift();
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectValidList() {
			this.logger.debug(this, "selectValidList()");
			axios
				.post(this.config.contextRoot + "/valid/selectValidList.do", {projectNo: this.items.projectNo})
				.then((response) => {
					console.log(response);
					this.validList = response.data.validList;
				})
				.catch((error) => { 
					this.exceptionHandler(this, error);
				});
		},
		selectItemList() {
			this.logger.debug(this, "selectItemList()");
			let param = {
				projectNo: this.items.projectNo,
				screeningNo: this.selectedScreeningNo,
			}
			axios
				.post(this.config.contextRoot + "/screening/selectItemList.do", param)
				.then((response) => {
					console.log(response);
					this.itemList = response.data.itemList;

					for(let i = 0; i < this.itemList.length; i++)
					{
						for(let j = 0; j < this.itemList[i].projectDictionaryList.length; j++)
						{
							for(let k = 0; k < this.itemList[i].projectDictionaryList[j].procedureList.length; k++)
							{
								for(let l = 0; l < this.itemList[i].projectDictionaryList[j].procedureList[k].procQuestionList.length; l++)
								{
									for(let p = 0; p < this.itemList[i].projectDictionaryList[j].procedureList[k].procQuestionList[l].fieldList.length; p++)
									{
										if (this.itemList[i].projectDictionaryList[j].procedureList[k].procQuestionList[l].fieldList[p].fieldTypeCd == "04") {
											if (this.itemList[i].projectDictionaryList[j].procedureList[k].procQuestionList[l].fieldList[p].fieldValue.indexOf(";") >= 0) {
												this.itemList[i].projectDictionaryList[j].procedureList[k].procQuestionList[l].fieldList[p].fieldValue = this.itemList[i].projectDictionaryList[j].procedureList[k].procQuestionList[l].fieldList[p].fieldValue.split(";");
											} else if (this.itemList[i].projectDictionaryList[j].procedureList[k].procQuestionList[l].fieldList[p].fieldValue.length > 0) {
												this.itemList[i].projectDictionaryList[j].procedureList[k].procQuestionList[l].fieldList[p].fieldValue = [this.itemList[i].projectDictionaryList[j].procedureList[k].procQuestionList[l].fieldList[p].fieldValue];
											} else {
												this.itemList[i].projectDictionaryList[j].procedureList[k].procQuestionList[l].fieldList[p].fieldValue = [];
											}
										}
									}
									for(let p = 0; p < this.itemList[i].projectDictionaryList[j].procedureList[k].procQuestionList[l].fieldRepeatList.length; p++)
									{
										if (this.itemList[i].projectDictionaryList[j].procedureList[k].procQuestionList[l].fieldRepeatList[p].fieldTypeCd == "04") {
											if (this.itemList[i].projectDictionaryList[j].procedureList[k].procQuestionList[l].fieldRepeatList[p].fieldValue.indexOf(";") >= 0) {
												this.itemList[i].projectDictionaryList[j].procedureList[k].procQuestionList[l].fieldRepeatList[p].fieldValue = this.itemList[i].projectDictionaryList[j].procedureList[k].procQuestionList[l].fieldRepeatList[k].fieldValue.split(";");
											} else if (this.itemList[i].projectDictionaryList[j].procedureList[k].procQuestionList[l].fieldRepeatList[p].fieldValue.length > 0) {
												this.itemList[i].projectDictionaryList[j].procedureList[k].procQuestionList[l].fieldRepeatList[p].fieldValue = [this.itemList[i].projectDictionaryList[j].procedureList[k].procQuestionList[l].fieldRepeatList[k].fieldValue];
											} else {
												this.itemList[i].projectDictionaryList[j].procedureList[k].procQuestionList[l].fieldRepeatList[p].fieldValue = [];
											}
										}
									}
								}
							}
						}
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
				
		},
		selectData(screening) {
			this.logger.debug(this, "selectData(screening)");

			this.selectedScreeningNo = screening.screeningNo;
			this.items.screeningNo = screening.screeningNo;
			
			let url = this.config.contextRoot + "/project/" + this.$route.params.projectNo + "/screening/" + screening.screeningNo;
			if (this.$route.path !== url)
			{
				EventBus.$emit("project-loading", true);
				this.$router.push(url);
				this.selectDataVisitList();
				this.selectItemList();
				this.disableApply();
				location.reload();
			}
		},
		disabledCheck(pageItem, visitItem, status){
			let result = false;
			for(let i = 0; i < this.applyValidVoList.length; i++){
				let detailVo = this.applyValidVoList[i].validDetailVo;

				for(let j = 0;  j < detailVo.validResultDsaList.length; j++){
					let dsaVo = detailVo.validResultDsaList[j];
					
					if(dsaVo.disabledTypeCd == 'VISIT'){
						if(dsaVo.dataRemoveYn == 'Y'){
							for(let k = 0; k < dsaVo.validResultDsaDetailList.length; k++){
								let dsaDetailVo = dsaVo.validResultDsaDetailList[k];

								if(dsaDetailVo.visitNo == visitItem.visitNo){
									result = true;
								}
							}
						}
						else if(dsaVo.dataRemoveYn == 'N'){
							// let outcomeCnt = 0;
							for(let k = 0; k < dsaVo.validResultDsaDetailList.length; k++){
								let dsaDetailVo = dsaVo.validResultDsaDetailList[k];
								
								if(dsaDetailVo.outcomeDataCnt > 0){
									if(dsaDetailVo.visitNo == visitItem.visitNo){
										if(status != null && status != '1'){
											result = false;
										}
									}
								}
							}
							// if(outcomeCnt > 0){
							// 	for(let k = 0; k < dsaVo.validResultDsaDetailList.length; k++){
							// 		let dsaDetailVo = dsaVo.validResultDsaDetailList[k];

							// 		if(dsaDetailVo.visitNo == visitItem.visitNo){
							// 			result = false;
							// 		}
							// 	}
							// }
							// else{
							// 	for(let k = 0; k < dsaVo.validResultDsaDetailList.length; k++){
							// 		let dsaDetailVo = dsaVo.validResultDsaDetailList[k];

							// 		if(dsaDetailVo.visitNo == visitItem.visitNo){
							// 			result = true;
							// 		}
							// 	}
							// }
						}
					}

					if(dsaVo.disabledTypeCd == 'PAGE'){
						if(dsaVo.dataRemoveYn == 'Y'){
							for(let k = 0; k < dsaVo.validResultDsaDetailList.length; k++){
								let dsaDetailVo = dsaVo.validResultDsaDetailList[k];
	
								if(dsaDetailVo.visitNo == visitItem.visitNo && dsaDetailVo.pageNo == pageItem.pageNo){
									result = true;
								}
							}
						}
						if(dsaVo.dataRemoveYn == 'N'){
							for(let k = 0; k < dsaVo.validResultDsaDetailList.length; k++){
								let dsaDetailVo = dsaVo.validResultDsaDetailList[k];
								
								if(dsaDetailVo.visitNo == visitItem.visitNo && dsaDetailVo.pageNo == pageItem.pageNo){
									if(status != null && status != '1'){
										result = false;
									}
									else{
										result = true;
									}
								}
							}
						}
					}
				}
			}

			return result;
		},
		doGotoPage(gotoVo){
			this.logger.debug(this, "parent");
			let pageItem = {}
			let visitItem = {}
			for (let i = 0; i < this.pageList.length; i++){
				if(gotoVo.goPageNo == this.pageList[i].pageNo){
					pageItem = this.pageList[i];
				}
			}
			
			for(let i = 0; i < this.visitList.length; i++){
				if(gotoVo.goVisitNo == this.visitList[i].visitNo){
					visitItem = this.visitList[i];
				}
			}

			// let gotoList = {pageItem: pageItem, visitItem: visitItem};
			
			if (this.projectItem.projectEntryUnitCd == "1") {
				if(this.disabledCheck(pageItem, visitItem))
				{
					this.$alert("Disabled Page","Warning","warning");
				}
				else
				{
					this.paramSigleCreate = {
						pageNo: pageItem.pageNo,
						centralEdcPageNo: pageItem.centralEdcPageNo,
						pageLabel: pageItem.pageLabel,
						pageName: pageItem.pageName,
						projectNo: this.items.projectNo,
						visitNo: visitItem.visitNo,
						centralEdcVisitNo: visitItem.centralEdcVisitNo,
						visitName: visitItem.visitName,
						visitPageList: visitItem.screeningVisitPageList,
						selectedScreeningNo: this.selectedScreeningNo,
						selectedScreeningName: this.selectedScreeningName,
						entryStatus: visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)],
					};
					this.isPreSingleCreate = true;
				}
			}
			// return gotoList;
		},
		selectPage(pageItem, visitItem) {
			this.logger.debug(this, "selectPage(" + pageItem + "," + visitItem + ")");
			if (this.projectItem.projectEntryUnitCd == "1") {
				if(this.disabledCheck(pageItem, visitItem))
				{
					this.$alert("disable Page","Warning","warning");
				}
				else
				{
					this.paramSigleCreate = {
						pageNo: pageItem.pageNo,
						centralEdcPageNo: pageItem.centralEdcPageNo,
						pageLabel: pageItem.pageLabel,
						pageName: pageItem.pageName,
						projectNo: this.items.projectNo,
						visitNo: visitItem.visitNo,
						centralEdcVisitNo: visitItem.centralEdcVisitNo,
						visitName: visitItem.visitName,
						visitPageList: visitItem.screeningVisitPageList,
						selectedScreeningNo: this.selectedScreeningNo,
						selectedScreeningName: this.selectedScreeningName,
						validList: this.validList,
						disableProcList: this.disableProcList,
						disableQuestionList: this.disableQuestionList,
						validResultMsg: this.validResultMsg,
						entryStatus: visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)],
					};
					this.isPreSingleCreate = true;
				}
			} else if (this.projectItem.projectEntryUnitCd == "2") {
				this.paramMultipleList = {
					pageNo: pageItem.pageNo,
					centralEdcPageNo: pageItem.centralEdcPageNo,
					pageLabel: pageItem.pageLabel,
					pageName: pageItem.pageName,
					projectNo: pageItem.projectNo,
					visitNo: visitItem.visitNo,
					centralEdcVisitNo: visitItem.centralEdcVisitNo,
					visitName: visitItem.visitName,
					visitPageList: visitItem.screeningVisitPageList,
					selectedScreeningNo: this.selectedScreeningNo,
					selectedScreeningName: this.selectedScreeningName,
					entryStatus: visitItem.visitPageUserList[visitItem.visitPageList.indexOf(pageItem.pageNo)],
				};
				this.isMultipleList = true;
			}
		},
		unAddPopup() {
			this.logger.debug(this, "unAddPopup()");
			this.isUnAdd = true;
		},
		updateUnAdd(item) {
			this.logger.debug(this, "unAddPopup()");

			let sortOrder = item.visitSortOrder.split('.', 1);

			for(let i = 0; i < this.visitList.length; i++){
				if(this.visitList[i].visitSortOrder == sortOrder){
					this.$set(item, "afterVisitNo", this.visitList[i].visitNo);
				}
			}

			this.unUpdate = [];
			this.unUpdate = item;
			this.isUnUpdate = true;
		},
		getAccessList(category){
			axios
				.post(this.config.contextRoot + "/access/getCategoryPrivilegeList.do", {privilegeCategory: category})
				.then((response) => {
					console.log(response);
					this.accessList = response.data.privilegeList;
					this.accessList.forEach((obj) =>{
						this.workCheck(obj);
					})
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		async workCheck(obj){
			let item = {};
			item = {
				userId: sessionStorage.getItem("userId"),
				projectNo: this.$route.params.projectNo,
				privilegeTypeCd: obj.privilegeTypeCd,
				privilegeCategory: obj.privilegeCategory,
				privilegeName: obj.privilegeName
			}
			obj.isAccess = await this.$accessAuth(item);
		},
		workAccessCheck(name){
			for(let  i = 0; i < this.accessList.length; i++){
				if(this.accessList[i].privilegeName == name){
					return this.accessList[i].isAccess;
				}
			}
		},
		getProjectStateCd() {
			// project 셋팅
			axios
				.post(this.config.contextRoot + "/project/select.do", {projectNo: this.$route.params.projectNo})
				.then((response) => {
					console.log(response);
					this.projectStateCd = response.data.item.projectStateCd;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		pdfDown(type){
			EventBus.$emit("project-loading", true);
			this.logger.debug(this, "pdfDown()");

			this.items.pdfType = type;

			axios
				.post(this.config.contextRoot + "/pdf/pdfDown.do", this.items)
				.then((response) => {
					console.log(response);
					this.doDownload(response.data);
					setTimeout(function() {
						EventBus.$emit("project-loading", false);
					}.bind(this), 1000);
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doDownload(data) {
			this.logger.debug(this, "doDownload(data)");
			const formData = new FormData();
			formData.append("fileName", data.fileName);

			axios
				.post(this.config.contextRoot + "/pdf/download.do", formData, {responseType: "blob"})
				.then((response) => {
					console.log(response);
					const url = window.URL.createObjectURL(
						new Blob([response.data], {type: response.headers["content-type"]})
					);
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", data.fileName);
					document.body.appendChild(link);
					link.click();
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		headRow(){
			this.height = this.$refs.headRow.scrollHeight;
		},
		headRowSet(){
			if(this.height > 48){
				var height = this.height + 2;
				return "height : " + height + "px";
			}
		},
		headThSet(){
			return "height : " + this.height + "px";
		},
	},
};
</script>

<style scoped>
.scroll-wrap {
	position: relative;
	width: 100%;
	height: calc(100% - 90px);
	border-bottom: 1px solid #ccc;
	overflow-x: visible;
	z-index: 0;
}

.scroll-thead-wrap {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	min-width: 100%;
	height: 48px;
	background-color: #fff;
	overflow-y: hidden;
	z-index: 10;
}

.scroll-thead-wrap tbody {
	visibility: hidden;
}

.scroll-tbody-wrap {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	min-width: calc(100% + 18px);
	height: 100%;
	overflow-y: scroll;
	z-index: 5;
}

.scroll-tbody-wrap thead {
	visibility: hidden;
}

.schedule-table tbody tr:last-child th, .schedule-table tbody tr:last-child td {
    border-bottom: none;
}
.queryOpened{
	position: absolute;
    right: calc(50% - 23px);
    top: -2px;
	color: #dd574f;
    font-weight: bold;
	font-size: 20px;
}
.openQueryDataList{
	position: absolute;
    left: 29px;
    top: 0;
    color: #dd574f;
    font-weight: bold;
    font-size: 20px;
}
.pdf-btn{
	display: inline-flex;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    float: right;
    height: 35px;
    padding: 0 25px;
    border-radius: 5px;
    background-color: #2bade0;
    font-weight: 600;
    font-size: 10.5pt;
    color: #fff;
}

.screening-left-wrap{
	display: none;
}
.screening-center-wrap{
	background-color: #fff;
    width: 100%;
    height: 100%;
	position: fixed;
	top: 0;
	left: 0;
    z-index: 5;
	padding: 20px;
}
.dialog-container{
	width: 100%;
	left: 0;
}
</style>
